import { render, staticRenderFns } from "./scrollBottom.vue?vue&type=template&id=782b02dd&scoped=true"
import script from "./scrollBottom.vue?vue&type=script&lang=js"
export * from "./scrollBottom.vue?vue&type=script&lang=js"
import style0 from "./scrollBottom.vue?vue&type=style&index=0&id=782b02dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b02dd",
  null
  
)

export default component.exports